<template>
    <div class="enterTit"><span>{{title}}</span></div>
</template>
<script>
    export default {
        props: ["title"],
        data() {
            return {

            }
        }

    }
</script>
<style scoped lang="scss">
    .enterTit{
        text-align: center;
    }
    .enterTit span{
        position: relative;
        width: auto;
        display: inline-block;
        text-align: center;
    }
    .enterTit span::before {
        width: 1.8229vw;
        height: 0.0521vw;
        background-color: #666666;
        display: block;
        content: "";
        position: absolute;
        left: -1.8229vw;
        top: 1.0938vw;
        z-index: 0;
    }
 .enterTit span::after {
    width: 1.8229vw;
	height: 0.0521vw;
	background-color: #666666;
    display: block;
    content: "";
    position: absolute;
    right: -1.8229vw;
    top: 1.0938vw;
    z-index: 0;
}
@media (max-width: 768px){
   
}
</style>